module.exports = __webpack_public_path__ + "static/pic-2e7bb926a204eee006245ee2440f1f7f.jpg";